import React, { useState } from "react";
import styles from "./BeveragesDialog.module.css";

import { createPortal } from "react-dom";
import { beverageCategories } from "./constants/beverage-categories";

export const BeveragesDialog = (props) => {
  const { onClose, initiallySelectedCategories, setCategories, customize } = props;
  const [selectedCategories, setSelectedCategories] = useState(initiallySelectedCategories);

  const isCategoryChecked = (category) => {
    return selectedCategories.includes(category);
  };

  const toggleCategory = (category) => {
    if (isCategoryChecked(category)) {
      setSelectedCategories(selectedCategories.filter((c) => c !== category));
    } else {
      setSelectedCategories([...selectedCategories, category]);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target.className === styles.overlay) {
      onClose();
    }
  };

  return createPortal(
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.dialog}>
        <button
          className={`${styles.closeButton} custom_click_track`}
          data-custom_click_track_value="Beverages|Close Categories Modal|internal"
          onClick={onClose}
          aria-label="Close consent popup"
        >
          ✕
        </button>
        <h2>Choose a beverage</h2>
        <p>
          Select your favorite drinks. Click &quot;Customize&quot; to make them more your own.
        </p>

        <div className={styles.categories}>
          {beverageCategories.map((category) => {
            const checkedCategory = isCategoryChecked(category.name);
            return (
              <label
                className={`${styles.category} ${checkedCategory ? styles.selectedCategory : null}`}
                key={category.name}
              >
                <input
                  type="checkbox"
                  className="custom_click_track"
                  data-custom_click_track_value={`Beverages|Category Selection: ${category.name}|internal`}
                  checked={checkedCategory}
                  onChange={() => toggleCategory(category.name)}
                />
                <img
                  src={checkedCategory ? category.activeIcon : category.icon}
                  alt={category.name}
                />
                <p>{category.name}</p>
              </label>
            );
          })}
        </div>
        <div className={styles.buttonArea}>
          <button
            onClick={() => {setCategories(selectedCategories); customize(); onClose()}}
            className={`${styles.primary} custom_click_track`}
            data-custom_click_track_value="Beverages|Customize|internal"
          >Customize</button>
        </div>
      </div>
    </div>,
    document.body,
  );
};
